import { useMemo } from "react";
import { Redirect, useLocation } from "react-router-dom";
import { GetInvestigationName } from '../../Components/CommonFunctions/CommonFunctions';

const PathChecker = ({ children, shouldRestrict }) => {
    const location = useLocation();
    const dynamicName = GetInvestigationName();

    const restrictedPrefixes = useMemo(() =>
        [
            // Fo restricted url
            "/BillingTransaction", "/FOReports", "/Settings", "/ChartDashboard",
            // lab
            "/LabReports", "/SettingsHome",
            // investigation
            `/${dynamicName}BillingTransaction`, `/${dynamicName}Reports`, `/${dynamicName}Settings`,
            // pharmacy
            "/PharmacyInvoice", "/PharmacyReports", "/PharmacySetting",
            // OT
            "/OTReports", "/OTSettings",
            // sublocation
            "/SubLocationReports",
            // canteen
            "/CanteenBillingTransaction", "/CanteenSettings",
            //asset 
            "/AssetSettings",
            // store 
            "/StoreReports", "/StoreSetting",
            // doctor module
            "/DoctorRegistry", "/DoctorSettings", "/DoctorReports", "/DoctorMRD",
            // organization
            "/AdminDashboard", "/Login", "/AdminSettings",
        ], []);

    const { pathname } = location;
    const isRestricted = shouldRestrict && restrictedPrefixes?.some(
        prefix => pathname.startsWith(prefix)
    );

    if (isRestricted) {
        return <Redirect to="/NoAccess" />;
    }
    return children;
};

export default PathChecker;